import { Toast } from '@single-platform/components';
import styled from 'styled-components';

export const InformationMessageToastStyles = styled(Toast)`
  display: flex;
  justify-content: center;
  margin: 10px 0px;
`;
